import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import DashboardContent from './DashboardContent';
import HeaderManagement from './HeaderManagement';
import BlogManagement from './BlogManagement';
import FooterManagement from './FooterManagement';
import SEOManagement from './SEOManagement';
import { useAuth } from '../context/AuthContext';

export default function Dashboard() {
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div className="flex flex-col lg:flex-row min-h-screen">
      {/* 30% Width Sidebar */}
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      {/* 70% Width Content Area */}
      <div className="flex-1 lg:w-[70%] bg-slate-950 min-h-screen">
        <div className="max-w-4xl mx-auto px-6 py-8">
          {activeTab === 'dashboard' && <DashboardContent currentUser={currentUser} />}
          {activeTab === 'header-management' && <HeaderManagement />}
          {activeTab === 'blog-management' && <BlogManagement />}
          {activeTab === 'footer-management' && <FooterManagement />}
          {activeTab === 'seo-management' && <SEOManagement />}
        </div>
      </div>
    </div>
  );
}
